import api from '../../../../resources/apiProvider'
import userService from '../../../../services/userService'
import _ from 'lodash'
import toastr from 'toastr/build/toastr.min'
import Treeselect, { ASYNC_SEARCH, LOAD_ROOT_OPTIONS} from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import listCategories from '../../../../resources/listCategories'

export default {
    name: 'adminUserManage',
    components: {Treeselect},
    data() {
        return {
            listUsers: null,
            listNetworks: null,
            listNetworksSelected: [],
            userInLocal: false,
            selectedWdrUser: undefined,
            isAdmin: false,
        }
    },
    watch: {
        getselectedWdrUser: function (val) {
            let vm = this
            let selectUserWdr = _.cloneDeep(val)
            if (selectUserWdr) {
                if(vm.getUserInfos("isAdmin")) {
                    vm.isAdmin = vm.getUserInfos("isAdmin")
                }
                vm.listNetworksSelected = []
                vm.getNetworksSelected()
            }

        }
    },
    created() {

    },
    mounted() {

    },
    methods: {
        async getListUser() {
            let resList = api.getFromUri(api.getResourceUri().user.base)
            let list = await resList.get()
            this.listLocalUser = list.data.rows
        },
        // Récupérer la liste des réseaux et catégories de base
        async getNetworks({ action ,callback }) {
            let vm = this
            if (action === LOAD_ROOT_OPTIONS) {

                let listAllNetworks = api.getFromUri(api.getResourceUri().todNetworks.base)
                const result = await listAllNetworks.get()

                vm.listNetworks = result.data ? result.data.map((network) => {
                    network.label = network.network
                    network.id = network.network
                    network.children = vm.getCategoryNetworksOptions(network)
                    //network.customLabel = network.network
                    return network
                }) : []
                console.log(vm.listNetworks)
                callback(null, vm.listNetworks)
            }
        },
        // Récupérer la liste des réseaux et catégories dont l'utilisateur sélectionné à les habilitations
        getNetworksSelected() {
            let vm = this
            const networksAuthorize = vm.getUserInfos("networksAuthorize")
            vm.listNetworksSelected = vm.getNetworksListUnformatted(networksAuthorize)
        },
        /**
         * Recherche asynchrone d'uilisateurs avec le champ texte
         */
        async searchUser({ action, searchQuery, callback }) {
            const vm = this
            if (action === ASYNC_SEARCH) {
                if (!searchQuery || searchQuery.length < 4) {
                    callback("Rentrez au moins 4 charactères", null)
                    return
                }
                const resWdrUser = api.getFromUri(api.getResourceUri().wdrUser.getAll)
                const result = await resWdrUser.get({searchQuery})
                const users = result.data.map((user) => { return {
                    id: user.id,
                    label: user.firstName + ' ' + user.lastName,
                    simpleReporting: user.simpleReporting,
                    todReporting: user.todReporting,
                }})
                vm.listUsers = users
                callback(null, users)
            }
        },
        /**
         * Sauvegarde des habilitations données à l'utilisateur
         */
        saveProcess() {
            let vm = this
            let selectUserWdr = vm.getselectedWdrUser

            let newUser = {
                id: selectUserWdr.id,
                todReporting: vm.getTodReportingObject
            }

            //let networksListFormatted = this.getNetworksListFormatted(this.listNetworksSelected)

            userService.updateUser(newUser).then(() => {
                toastr.success('Enregistrement effectué')
            })

        },
        /**
         * Récupérer l'info indiquée de l'utilisateur
         */
        getUserInfos(info) {
            if (!this.getselectedWdrUser) {
                return false
            }
            const user = this.getselectedWdrUser
            // eslint-disable-next-line
            return !_.isUndefined(user['todReporting'][info]) ? user['todReporting'][info] : undefined
        },
        /**
         * Récupérer les catégories enfants de base du réseau au format vue-treeselect
         *
         * Il s'agit en fait de la liste standard des catégories appliquées au réseau donné
         */
        getCategoryNetworksOptions(network) {
            let listOptions = []
            listCategories.forEach(function(item) {
                let newItem = {
                    id : network.network + '|' + item.label,
                    label : network.network + ' : ' + item.label,
                }
                listOptions.push(newItem)
            })
            return listOptions
        },
        /**
         * Récupérer les catégories enfants sélectionnées du réseau
         */
        getSelectedCategoryNetworksOptions(network) {
            let listOptions = []
            network.categoriesAuthorize.forEach(function(category) {
                let newItem = {
                    id : network.network + '|' + category,
                    label : category
                }
                listOptions.push(newItem)
            })
            return listOptions
        },
        /**
         * Transformer la liste récupérée de vue-treeselect en objet JS pour mongo
         *
         * vue-treeselect ne retourne pas les valeurs sous forme d'arbre comme nous les avons dans dm_user
         * Permet de transformer les valeurs récupérées du treeselect en un objet JS ayant la même structure que les habilitations dans dm_user
         */
        getNetworksListFormatted(arr)
        {
            let finalArray = []
            arr.forEach(function(item){
                if(item.id.split('|')[1]) {
                    let parent = finalArray.find(function(element) {
                        return element.network == item.id.split('|')[0]
                    })
                    if(parent) {
                        parent.categoriesAuthorize.push(item.id.split('|')[1])
                    }
                    else {
                        let newParent = {
                            network: item.id.split('|')[0],
                            categoriesAuthorize: []
                        }
                        newParent.categoriesAuthorize.push(item.id.split('|')[1])
                        finalArray.push(newParent)
                    }
                }
                else {
                    let newParent = {
                        network: item.label,
                        categoriesAuthorize: []
                    }
                    listCategories.forEach(function(item) {
                        newParent.categoriesAuthorize.push(item.label)
                    })
                    finalArray.push(newParent)
                }
            })
            return finalArray
        },
        /**
         *  Formater la liste récupérée de mongo pour vue-treeselect
         */
        getNetworksListUnformatted(arr)
        {
            let finalArray = []
            let newItem
            arr.forEach(function(network) {
                if(network.categoriesAuthorize.length == listCategories.length)
                {
                    newItem = {
                        id : network.network,
                        label : network.network,
                        //customLabel : network.network
                    }
                    finalArray.push(newItem)
                }
                else {
                    network.categoriesAuthorize.forEach(function(category) {
                        newItem = {
                            id : network.network + '|' + category,
                            label : network.network + ' : ' + category,
                            //customLabel : network.network + ' ' + category
                        }
                        finalArray.push(newItem)
                    })
                }

            })
            return finalArray
        }
    },
    computed: {
        userIsAdmin() {
            return this.$store.storeAuth.getters.isAdmin
        },
        getselectedWdrUser() {
            if (!this.selectedWdrUser || _.isEmpty(this.selectedWdrUser)) {
                return undefined
            }
            return this.listUsers.find((user) => this.selectedWdrUser === user.id )
        },
        enableNetworkList() {
            return this.getselectedWdrUser
        },
        getTodReportingObject() {
            return {
                isAdmin: this.isAdmin,
                networksAuthorize: this.getNetworksListFormatted(this.listNetworksSelected)
            }
        }
    },
}